import script from "./SearchModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchModal.vue?vue&type=script&setup=true&lang=ts"

import "./SearchModal.vue?vue&type=style&index=0&id=7ca50a30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca50a30"]])

export default __exports__